// Description: This endpoint is used to save the channel data in the database.
// Updated: 21/08/2025
// Author: Vitor de Jesus

import axios from 'axios';

export async function ChannelCheck({code, name}) {
    try {
        
        const token = localStorage.getItem('jwt_token');
        const clientId = localStorage.getItem('idToken');

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!clientId) throw new Error('ID do cliente não encontrado');

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_AWS_URL}/channels/whatsapp/web/save`, 
            {
                code,
                name
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    'Client_ID': `${clientId}`
                },
            }
                
        );
        
        const responseData = response.data;
        console.log('responseData', responseData);

        return responseData;
    } catch (error) {
        console.error('Erro ao buscar dados da API:', error.response ? error.response.data : error.message);
        throw new Error('Erro ao buscar dados da API');
    }
    
}